// extracted by mini-css-extract-plugin
module.exports = {"illustration":"Illustration_illustration__dsNtE"};